export const tachoSnapshotItemsPageSize = 25;

export function pluralise(count, singular, plural) {
    if (count === 1) {
        return singular;
    }

    return plural;
}

export function pageOf(items, pageNumber, pageSize) {
    const pageStart = (pageNumber - 1) * pageSize;
    return items.slice(pageStart, pageStart + pageSize);
}

export function countPages(items, pageSize) {
    return Math.max(1, Math.ceil(items.length / pageSize));
}
